// VARIOUS CACHE RELATED CODE
import store from "Js/store";

// Parse a storage value; remove the key on invalid JSON.
// (e.g. literal "undefined" from setItem(key, JSON.stringify(undefined)))
function parseStorageOrClear(storage, key) {
  try {
    return { ok: true, value: JSON.parse(storage.getItem(key)) };
  } catch (e) {
    storage.removeItem(key);
    return { ok: false };
  }
}

function writeStorageValue(storage, key, newValue) {
  const serialized = JSON.stringify(newValue);
  // JSON.stringify(undefined) === undefined; setItem would coerce to "undefined"
  if (serialized === undefined) {
    storage.removeItem(key);
    return;
  }
  storage.setItem(key, serialized);
}

//Register watchers for app model - could be moved into site
export const cacheRegListeners = function() {
  _.forEach(store.state.site.content.appCaching, function(c) {
    store.watch((state) => state.site.content.app[c.path], cacheCbGen(c));
  });
}

export const cacheAppLoad = function() {
  // TODO pass in state vs vueapp
  _.forEach(vueapp.$store.state.site.content.appCaching, function(c) {
    let app = {};

    if (c.sessionStorage && c.path in sessionStorage) {
      const parsed = parseStorageOrClear(sessionStorage, c.path);
      if (!parsed.ok) {
        return; // corrupt value was cleared; leave app untouched
      }
      app[c.path] = parsed.value;
      vueapp.$store.commit('SET_APP', app);

    }
    else if (c.localStorage && c.path in localStorage) {
      const parsed = parseStorageOrClear(localStorage, c.path);
      if (!parsed.ok) {
        return; // corrupt value was cleared; leave app untouched
      }
      app[c.path] = parsed.value;
      vueapp.$store.commit('SET_APP', app);
    }
  })
}

// returns a cb function that is called when a watched app/form key is changed
export const cacheCbGen = function(c) {
  return function(newValue) {
    if (c.appSync) {
      vueapp.$store.state.site.content.app[c.path] = newValue
    }
    try {
      const key = (c.pathPrefix || '') + c.path;
      c.localStorage ? writeStorageValue(localStorage, key, newValue) : null;
      c.sessionStorage ? writeStorageValue(sessionStorage, key, newValue) : null;
    }
    catch(e) {
      BF.errorThrow (10171, `Unable to add key to local or session storage. Removing key from storage.`, 'Error encountered while attempting to write data to local or session storage.');
      c.localStorage ? localStorage.removeItem((c.pathPrefix || '') + c.path) : null;
      c.sessionStorage ? sessionStorage.removeItem((c.pathPrefix || '') + c.path) : null;
    }
  };
};


export const appSyncCbGen = function(c, state, ind) {
  return function(newValue) {
    if (c.appSync) {
      state.windows[ind].formSchema.model[c.path] = newValue
    }
  };
};

// Register watchers for page models
export const cacheFormAdd = function(state, wndw, ind) {
  let prefix = wndw.formSchema.id + '_' // TODO should be navigational path (slug) of the page
  let modelCaches = wndw.formSchema.modelCaches || // []
    [
      { path: 'local', localStorage: true },
      { path: 'session', sessionStorage: true },
      { path: 'both', localStorage: true, sessionStorage: true }
    ] // temp simulate a key

  _.forEach(modelCaches, function(c) {
    // Listener for app if appSync
    if (c.appSync) {
      // watch app for changes
      let cb = store.watch(
        (state) => {
          return state.site.content.app[c.path]
        },
        appSyncCbGen(c, state, ind), {
          immediate: true, // returning to a page sync down
          deep: true
        });
      state.windows[ind].cacheRemove.push(cb);
    }

    // for ls, ss, appsync add a model watcher
    if (c.appSync || c.localStorage || c.sessionStorage) {
      c.pathPrefix = prefix
      let cb = store.watch(
        (state) => {
          return state.wndw.windows[ind].formSchema.model[c.path]
        },
        cacheCbGen(c),
        {
          deep: true
        });

      state.windows[ind].cacheRemove.push(cb);
    }

  });
};

// Getting data from local / session storage
export const cacheFormLoad = function(state, wndw, ind) {
  let prefix = wndw.formSchema.id + '_'
  let caches = wndw.formSchema.modelCaches || []
  _.forEach(caches, function(c) {
    let model = {};
    let fullpath = prefix + c.path
    if (c.sessionStorage && fullpath in sessionStorage) {
      const parsed = parseStorageOrClear(sessionStorage, fullpath);
      if (!parsed.ok) {
        return; // corrupt value was cleared; leave model untouched
      }
      model[c.path] = parsed.value;
      Object.assign(state.windows[ind].formSchema.model, model)
    }
    else if (c.localStorage && fullpath in localStorage) {
      const parsed = parseStorageOrClear(localStorage, fullpath);
      if (!parsed.ok) {
        return; // corrupt value was cleared; leave model untouched
      }
      model[c.path] = parsed.value;
      Object.assign(state.windows[ind].formSchema.model, model)
    }
  })
};

// Remove watchers for page models via callbacks
export const cacheFormRemove = function(state, ind) {
  let cbs = state.windows[ind].cacheRemove
  _.forEach(cbs, function(cb) {
    cb();
  })
  state.windows[ind].cacheRemove = []
};

// TODO remove
// Returns the cached site if present
export const cacheSiteLoad = function() {

};

// Saves the passed site to cache
export const cacheSiteSave = function() {


};
